import React, { useEffect } from "react";
import Login from "../Auth/Login";
import { Navigate, useLocation, useRoutes } from "react-router-dom";
import Dashboard from "../Dashboard/Dashboard";
import TenantDetail from "../TenantDetail/TenantDetail";
import AppLayout from "../AppLayout/AppLayout";
import NotFoundPage from "../Common/NotFoundPage";
import Features from "../Features/Index";
import Prompt from "../Prompt";
import SystemPrompt from "../SystemPrompt";
// import FaviconLogo from "../../assets/images/Iseeit-fav.png"

const ProtectedRoute = ({ children }) => {
  const favicon = document.querySelector('link[rel="icon"]');
  const shortcutIcon = document.querySelector('link[rel="shortcut icon"]');

  // if (favicon) {
  //     favicon.href = FaviconLogo;
  // }
  // if (shortcutIcon) {
  //     shortcutIcon.href = FaviconLogo;
  // }

  const isAuthenticated = !!localStorage.getItem("token");

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const RoutesComponent = () => {
  const location = useLocation();

  const appRoutes = [
    {
      path: "/login",
      element: <Login />,
      title: "Login | Multi-Tenant Learnify",
    },
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <AppLayout />
        </ProtectedRoute>
      ),
      children: [
        {
          path: "dashboard",
          element: <Dashboard />,
          title: "Dashboard | Multi-Tenant Learnify",
        },
        {
          path: "features",
          element: <Features />,
          title: "Features | Multi-Tenant Learnify",
        },
        {
          path: "prompt",
          element: <Prompt />,
          title: "Prompt | Multi-Tenant Learnify",
        },
        {
          path: "system-prompt",
          element: <SystemPrompt />,
          title: "System Prompt | Multi-Tenant Learnify",
        },
        {
          path: "tenant/detail",
          element: <TenantDetail />,
          title: "Tenant Detail | Multi-Tenant Learnify",
        },
      ],
    },
    {
      path: "*",
      element: <NotFoundPage />,
      title: "Page not found | Multi-Tenant Learnify",
    },
  ];

  const findRouteTitle = (routes, path) => {
    for (const route of routes) {
      if (route.path === path) {
        return route.title;
      }
      if (route.children) {
        const childTitle = findRouteTitle(
          route.children,
          path.replace(/^\//, "")
        );
        if (childTitle) {
          return childTitle;
        }
      }
    }
    return null;
  };

  useEffect(() => {
    const currentTitle = findRouteTitle(appRoutes, location.pathname);
    document.title = currentTitle || "Multi - Tenant LMS | Dashboard";
  }, [location]);

  useEffect(() => {
    const favicon = document.querySelector('link[rel="icon"]');
    const shortcutIcon = document.querySelector('link[rel="shortcut icon"]');

    // if (favicon) {
    //     favicon.href = FaviconLogo;
    // }
    // if (shortcutIcon) {
    //     shortcutIcon.href = FaviconLogo;
    // }
  }, []);

  return useRoutes(appRoutes);
};

export default RoutesComponent;
